export const timezones = [
    {value: 2, label: 'UTC+2 Калининград'},
    {value: 3, label: 'UTC+3 Москва'},
    {value: 4, label: 'UTC+4 Самара'},
    {value: 5, label: 'UTC+5 Екатеринбург'},
    {value: 6, label: 'UTC+6 Омск'},
    {value: 7, label: 'UTC+7 Новосибирск'},
    {value: 8, label: 'UTC+8 Иркутск'},
    {value: 9, label: 'UTC+9 Чита'},
    {value: 10, label: 'UTC+10 Владивосток'},
    {value: 11, label: 'UTC+11 Магадан'},
    {value: 12, label: 'UTC+12 Петропавловск-Камчатский'},
]



